import React, { useEffect, useState } from 'react';
export const FloatingElements = () => {
  const [price, setPrice] = useState(29.95);
  useEffect(() => {
    const handlePriceUpdate = (e: any) => {
      setPrice(e.detail.total);
    };
    window.addEventListener('priceUpdate', handlePriceUpdate);
    return () => window.removeEventListener('priceUpdate', handlePriceUpdate);
  }, []);
  return <>
      {/* Mobile Sticky CTA */}
      <div className="fixed bottom-0 left-0 w-full bg-dark-1 border-t-2 border-halloween-orange p-3 z-40 md:hidden flex justify-between items-center shadow-[0_-10px_30px_rgba(0,0,0,0.8)]" data-id="element-174" data-mp="42l74jzjy8np">
        <div className="flex flex-col" data-id="element-175" data-mp="3r942cb6jzhdd">
          <span className="font-bebas text-2xl text-white leading-none" data-id="element-176" data-mp="3ra6pq94o31oj">
            ${price.toFixed(2)}
          </span>
          <span className="font-barlow text-[10px] text-halloween-orange font-bold tracking-widest uppercase" data-id="element-177" data-mp="3vuwuq92x5n">
            60% OFF — FREE SHIPPING
          </span>
        </div>
        <button onClick={() => {
        const target = document.getElementById('the-mask');
        if (!target) return;
        // Account for the fixed top bar + nav so the section lands in view
        // instead of scrolling under the header (which reads as a black gap).
        const headerOffset = 96;
        const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({
          top: Math.max(0, top),
          behavior: 'smooth'
        });
      }} className="bg-acid-green text-black font-barlow font-bold text-sm tracking-[2px] px-8 py-3 clip-diagonal active:bg-white" data-id="element-178" data-mp="1ufamlh2tn6o1">
          SHOP NOW
        </button>
      </div>
    </>;
};